export enum MeshType {
	CLOSED = 'closed',
	OPENED = 'open',
}
